// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-style{padding:10px 0}.demo-input-suffix{display:flex;position:relative}.demo-input-suffix label{width:120px;line-height:37px}.demo-input-suffix input{height:30px!important;line-height:30px!important;font-size:14px!important;width:80%;display:inline-table}.demo-input-suffix .label-Warning{color:red;position:absolute;top:40px;font-size:12px;left:88px}.padding__inner input.el-input__inner{padding:16px 0;font-size:20px!important}", ""]);
// Exports
module.exports = exports;
